import { GoDotFill } from "react-icons/go";

const InvestmentSection = () => {
  const bgImageOne = "./assets/frambg.png";

  return (
    <section className="w-full py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        <button className="flex items-center justify-center mx-auto gap-1 text-[#32AE4C] border border-[#32AE4C] tracking-wider px-2 md:px-4 py-1 md:py-1 lg:py-1 rounded-full text-xs md:text-xs  xl:text-sm ">
          <GoDotFill className="w-3 h-3  lg:w-4 lg:h-4" />
          <p className="whitespace-now-rap">Invest With Us </p>
        </button>
        <h2 className="text-lg md:text-2xl lg:text-[28px] xl:text-3xl font-bold max-w-sm md:max-w-lg lg:max-w-[560px] mx-auto text-center mb-4">
          All-in-one investment solutions
        </h2>

        <p className="text-center text-sm md:text-base text-[#6F6F6F]  max-w-sm md:max-w-lg lg:max-w-xl mx-auto mb-16">
          Whether you're new to investing or a seasoned trader, Vant provides
          the tools and options to grow your money effectively.
        </p>

        <div className="flex flex-col md:flex-row gap-12">
          <div
            className="w-full md:w-[50%] relative  rounded-3xl pt-5  md:pt-9 lg:pt-12 pb-4  md:pb-7 lg:pb-10 h-[300px] md:h-[420px]"
            style={{
              backgroundImage: `url('${bgImageOne}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >

              <img src="./assets/deluxe.svg" alt="Centered Image" className="absolute h-[250px] md:h-[300px] xl:h-[320px] bottom-0 left-1/2 transform -translate-x-1/2" />

            </div>


          <div className="flex-1 flex flex-col justify-center">
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-8 h-8 md:h-10 md:w-10  rounded-full bg-[#EBF7ED] flex items-center justify-center flex-shrink-0">
                <p className="text-[#32AE4C]">₦</p>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-lg lg:text-xl font-medium mb-2">
                  Deluxe investment Plan
                  </h3>
                  <p className="text-[#6F6F6F] text-sm md:text-base">
                    Access stocks, ETFs, crypto, and bonds all in one place to
                    diversify your investments.
                  </p>
                </div>
              </div>

               <div className="flex gap-4">
                <div className="w-8 h-8 md:h-10 md:w-10  rounded-full bg-[#EBF7ED] flex items-center justify-center flex-shrink-0">
                <p className="text-[#32AE4C]">₦</p>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-lg lg:text-xl font-medium mb-2">
                 Grow investment Plan
                  </h3>
                  <p className="text-[#6F6F6F] text-sm md:text-base">
                    With the grow plan, you can earn up to 10% P.A with a minimum of 3 unit. You will have access to make withdrawals after 3 months.
                  </p>
                </div>
              </div>
               <div className="flex gap-4">
                <div className="w-8 h-8 md:h-10 md:w-10  rounded-full bg-[#32AE4C] flex items-center justify-center flex-shrink-0">
                <p className="text-[#fff]">₦</p>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-lg lg:text-xl font-medium mb-2">
                Surge investment Plan
                  </h3>
                  <p className="text-[#6F6F6F] text-sm md:text-base">
                   With the surge plan, you can earn up to 13% P.A with a minimum of 5 unit. You will have access to make withdrawals after 6 months.
                  </p>
                </div>
              </div>

               <div className="flex gap-4">
                <div className="w-8 h-8 md:h-10 md:w-10  rounded-full bg-[#EBF7ED] flex items-center justify-center flex-shrink-0">
                <p className="text-[#32AE4C]">₦</p>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-lg lg:text-xl font-medium mb-2">
                  HNI investment Plan
                  </h3>
                  <p className="text-[#6F6F6F] text-sm md:text-base">
                 With the HNI investment plan, you can customize the plan to suit your finances with risk appetite most convenient to you. Sounds cool, right?
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="bg-[#32AE4C] p-2 md:p-6 lg:p-8 rounded-xl text-white flex flex-col items-center justify-center">
            <h3 className="md:text-2xl text-xl lg:text-3xl font-bold mb-2">$6B+</h3>
            <p className="text-center">Gaining new users every single month.</p>
          </div>

          <div className="bg-[#32AE4C] p-2 md:p-6 lg:p-8 rounded-xl text-white flex flex-col items-center justify-center">
            <h3 className="md:text-2xl text-xl lg:text-3xl font-bold mb-2">234<sup>M</sup></h3>
            <p className="text-center">Supporting multiple currencies for users.</p>
          </div>

          <div className="bg-[#F2F5F7] p-2 md:p-6 lg:p-8 rounded-xl text-white flex flex-col items-center justify-center">
            <h3 className="md:text-2xl text-xl lg:text-3xl font-bold mb-2 text-[#282828]">5.0★</h3>
            <p className="text-center text-[#5c2c2c]">High star ratings from satisfied users.</p>
          </div>

          <div className="bg-[#F2F5F7] p-2 md:p-6 lg:p-8 rounded-xl text-white flex flex-col items-center justify-center">
            <h3 className="md:text-2xl text-xl lg:text-3xl font-bold mb-2 text-[#282828]">N5.8<sup>M</sup></h3>
            <p className="text-center text-[#282828]">Generating increased revenue consistently</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentSection;
